import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';
export default class ComponentToPrint extends React.Component {

  render() {
    const dayWiseCropSupplyDetails = this.props.dayWiseCropSupplyDetails;
    const total = this.props.total;
    const searchData = this.props.searchData;
    
    const formattedStartDate = new Date(searchData.startDate).toISOString().split('T')[0].replace(/-/g, '/');
    const formattedEndDate = new Date(searchData.endDate).toISOString().split('T')[0].replace(/-/g, '/');

    return (
      
      <div>
        <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
          <br />
          <h2><center><u>Day Wise Crop Report</u></center></h2>
          <div>&nbsp;</div>
          <h3><center>{searchData.groupName} - {searchData.factoryName}</center></h3>
          <h3><center>{searchData.routeName  == undefined ? 'Route : All Routes' : 'Route : ' + searchData.routeName}</center></h3>
          <h3><center>From Date {formattedStartDate} - To Date {formattedEndDate}</center></h3>
          <h3><center>{searchData.registrationNumber == undefined ? 'Registration Number: All Registration Numbers' : 'Registration Number: '+searchData.registrationNumber}</center></h3>
          <div>&nbsp;</div>
          <div>
            <Box minWidth={1050}>
              <TableContainer>
                <Table aria-label="caption table" size="small" >
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ border: '1px solid #ccc' }} align={'center'}>Date</TableCell>
                      <TableCell style={{ border: '1px solid #ccc' }} align={'center'}>Route Name</TableCell>
                      <TableCell style={{ border: '1px solid #ccc' }} align={'center'}>Reg No</TableCell>
                      <TableCell style={{ border: '1px solid #ccc' }} align={'center'}>Supplier Name</TableCell>
                      <TableCell style={{ border: '1px solid #ccc' }} align={'center'}>Leaf Type</TableCell>
                      <TableCell style={{ border: '1px solid #ccc' }} align={'center'}>Net Weight (KG)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dayWiseCropSupplyDetails.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", border: '1px solid #ccc' }}>
                          {data.cropCollectedDate.split("T")[0]}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", border: '1px solid #ccc' }}>
                          {data.routeName}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", border: '1px solid #ccc' }}>
                          {data.registrationNumber}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", border: '1px solid #ccc' }}>
                          {data.name}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", border: '1px solid #ccc' }}>
                          {data.collectionTypeName}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", border: '1px solid #ccc' }}>
                          {data.netWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableRow style={{ borderRight: '1px solid #ccc' }}>
                    <TableCell align={'left'} style={{ border: '1px solid #ccc' }}><b>Total</b></TableCell>
                    <TableCell align={'left'} component="th" scope="row">
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row">
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row">
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderRight: '1px solid #ccc' }}>
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row">
                      <b> {total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </b>
                    </TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </Box>
          </div>
        </div></div>
    );
  }
}
